<template>
    <q-card class="card-product full-height bg-white" >

        <div v-if="editionSalesFlag" class="card-body bg-primary text-white q-pa-sm edition-sales-flag">{{ editionSalesFlag }}</div>
        <div :style="isTopCard ? 'min-height: 345px;' : ''">
            <div class="rounded-borders card-body q-px-sm" :class="isTopCard ? 'q-pt-xl q-pb-md' : 'q-pt-lg'">
                <div v-if="productLogo">
                    <router-link :to="productPage"><img :src="productLogo" :title="productName + ' Product Logo'" class="img-logo" style="height: 3em;" /><sup v-if="product" class="text-black text-weight-bold on-right q-mr-lg" style="font-size: 1rem; float: right; margin-top: -11px;">{{ productYear }}</sup></router-link>
                </div>
                <div v-if="product">
                    <div v-if="product.productCategoryID != 'LengthWise'" class="text-h5 text-weight-bold text-primary">{{ product.description }}</div>
                </div>
            </div>
            
            <div v-if="features && features.length > 0" class="q-mt-lg">
                <q-separator />
                <div class="card-body q-pa-none q-ma-none" :style="product.productCategoryID == 'LoopCAD' ? 'min-height: 16em;' : 'min-height: 8.5em;'" style="font-size: 0.9rem;">
                    <q-list v-for="feature of features" :key="feature">
                        <q-item dense class="cursor-inherit text-left q-px-lg">
                            <q-item-section>
                                <div v-if="feature.includes('plus...')">{{ feature }}</div>
                                <div :class="{'q-px-md' : screenSize.xs, 'q-px-lg' : !screenSize.xs}" v-if="!feature.includes('plus...')">
                                    <span style="margin-left: -12.5px;">● </span>{{ feature }}
                                </div>
                            </q-item-section>
                        </q-item>
                    </q-list>
                </div>
                <q-separator />
            </div>

            <q-separator v-if="product && product.productCategoryID == 'PlumbingCAD'" class="q-mt-lg" />

            <div class="rounded-borders card-body q-pt-lg q-px-sm" :class="isTopCard ? 'q-pb-xl' : 'q-pb-lg'">
                <div class="text-center q-pb-lg text-black">
                    <div v-if="product && !isTopCard" class="text-body1 text-weight-bold q-pb-sm">{{ productType(product) }}</div>
                    <div v-if="product" class="row items-center">
                        <span class="text-h4 text-primary text-weight-medium col-7 text-right"><small class="vertical-top">$</small>{{ getCurrency(product) }}</span><span class="col-5 text-left q-pl-xs q-pt-sm">{{ currency }}<span v-if="product.productCategoryID == 'PlumbingCAD'" style="font-size: 0.75em;">/12 months</span></span>
                    </div>
                    <div v-else-if="productName == 'PlumbingCAD'">
                        <span class="text-h4 text-primary text-weight-medium col-7 text-right"><small class="vertical-top">$</small>{{ lowestLicensePrice }}</span><span class="col-5 text-left q-pl-xs q-pt-sm">{{ currency }}<span style="font-size: 0.75em;">/12 months</span></span>
                    </div>
                    <div v-else class="row items-center justify-center">
                        <span style="font-size: 0.75em; position: absolute; margin-bottom: 50px; margin-left: -35%;">Starting at</span>
                        <span class="text-h4 text-primary text-weight-medium col-xs-auto text-right col-md-7"><small class="vertical-top">$</small>{{ lowestLicensePrice ? lowestLicensePrice : ' --- '  }}</span><span class="col-xs-auto col-md-5 text-left q-pl-xs q-pt-sm">{{ currency }}</span>
                    </div>
                </div>
                <div v-if="product" class="q-px-md" :class="{ 'q-pt-sm' : isTopCard }">
                    <q-btn class="full-width q-mb-xs"
                           color="positive" size="1rem"
                           icon="mdi-cart"
                           label="Buy License"
                           @click="addToCart(product)" />
                </div>
                <div v-if="!product" :class="{'q-px-md' : screenSize.gt.xs, 'q-px-sm' : screenSize.lt.sm, 'q-pt-sm' : isTopCard }">
                    <q-btn class="full-width q-mb-xs"
                           color="positive" size="1rem"
                           label="View Pricing"
                           @click="$emit('scrollToEditions')" />
                </div>
                <div v-if="isTopCard">
                    <div class="row justify-center q-px-sm">
                        <div class="col-xs-12 q-px-xs q-pt-sm col-sm-auto">
                            <q-btn color="primary"
                                   :to="productPage"
                                   class="full-width"
                                   style="font-size: 0.75rem;"
                                   label="Learn More" />
                        </div>
                        <div class="col-xs-12 q-px-xs q-pt-sm col-sm-auto">
                            <q-btn class="full-width bg-white text-primary"
                                   :to="freeTrialPage"
                                   style="font-size: 0.75rem; border: 1px solid currentColor; height: 95%;"
                                   label="Free Trial" />
                        </div>
                    </div>
                </div>
                <div v-if="renewal" class="text-center q-pt-lg text-black q-px-md" style="font-size: 0.8em;">
                    <span v-if="renewal.productCategoryID == 'PlumbingCAD'">New 12 month subscription</span>
                    <span v-else>License includes 12 months of updates and support</span>
                </div>
                <div v-if="!isTopCard && product && !(features && features.length > 0)">
                    <div class="text-body2 q-pt-md">
                        {{ product.webText }}
                    </div>
                </div>
            </div>
            <div v-if="renewal">
                <q-separator />
                <div class="card-body q-py-lg q-px-sm" style="border-bottom-left-radius: 4px; border-bottom-right-radius: 4px;">
                    <div class="text-center q-pb-lg text-black">
                        <div class="text-body1 text-weight-bold q-pb-sm">{{ productType(renewal) }}</div>
                        <div class="row items-center">
                            <span class="text-h4 text-primary text-weight-medium col-7 text-right"><small class="vertical-top">$</small>{{ getCurrency(renewal) }}</span><span class="col-5 text-left q-pl-xs q-pt-sm">{{ currency }}<span style="font-size: 0.75em;">/12 months</span></span>
                        </div>
                    </div>
                    <div class="q-px-md">
                        <q-btn class="full-width q-b-xs"
                               color="positive" size="1rem"
                               icon="mdi-cart"
                               label="Buy Renewal"
                               @click="addToCart(renewal)" />
                    </div>
                    <div class="text-center q-pt-lg text-black q-px-md" style="font-size: 0.8em;">
                        <span v-if="renewal.productCategoryID == 'PlumbingCAD'">Renewal will add 12 months to an active subscription</span>
                        <span v-else>Renewal purchase requires prior purchase of full license</span>
                    </div>
                </div>
            </div>
        </div>
        <q-separator v-if="productDescription" />
        <div v-if="productDescription" class="card-body rounded-borders q-pa-none q-ma-none bg-grey-2" style="min-height: 175px;">
            <div class="text-body2 q-pa-md" v-html="productDescription" />
        </div>
    </q-card>
</template>

<script>

    export default {
        name: 'store-product',
        props: {
            features: Array,
            product: Object,
            renewal: Object,
            lowestLicensePrice: {
                default: null,
                type: Number
            },
            productLogo: {
                default: null,
                type: String
            },
            productPage: {
                default: null,
                type: String
            },
            productName: {
                default: null,
                type: String
            },
            productYear: {
                default: null,
                type: String
            },
            productDescription: {
                default: null,
                type: String
            },
            editionSalesFlag: {
                default: null,
                type: String
            }
        },
        methods: {
            addToCart(prod) {
                if (prod.isSubscription)
                    this.$emit('renew', prod)
                else
                    this.$emit('buy', prod)
            },
            getCurrency(product) {
                if (this.cart.currency == 1) return product.listPriceCDN
                else return product.listPriceUS
            },
            productType(prod) {
                if (prod.isSubscription) return '12-Month Subscription Renewal'
                if (prod.isUpgrade) return 'Upgrade'
                return 'New License'
            },
        },
        computed: {
            cart() { return this.$store.getters.cart },
            currency() {
                if (this.cart.currency == 1) return 'CAD'
                else return 'USD'
            },
            screenSize() {
                return this.$q.screen
            },
            freeTrialPage() {
                return this.productPage + "#trial"
            },
            isTopCard() {
                if (!this.product || this.product.productCategoryID == 'LengthWise') {
                    return true;
                }
                else {
                    return false;
                }
            },
        },

    }
</script>
<style lang="scss" scoped>

    .edition-sales-flag {
        position: absolute;
        width: 100%;
        height: 40px;
        margin-top: -50px;
        font-size: 1.15rem;
    }

</style>
